import { defineStore } from 'pinia';
import { ContentV2, ContentType, ReactionType } from '@front-app/services/GroupsApi/DiscussionModel';
import { reactToContent } from '@front-app/services/GroupsApi/GroupsContentApi';
import { useDiscussionMessageStore } from '@front-app/store/piniaModules/discussionMessages';
import { useDiscussionStore } from '@front-app/store/piniaModules/discussions';

interface GroupContentStoreState {
	content: ContentV2[];
	selectedContentId: string;
}

export const useGroupContentStore = defineStore('groupContentStore', {
	state: (): GroupContentStoreState => ({
		content: [],
		selectedContentId: '',
	}),
	getters: {
		getById(state) {
			return (contentId: string) => state.content.find(({ id }) => id === contentId);
		},
	},
	actions: {
		update(newGroupContent: ContentV2[]) {
			this.$patch((state: GroupContentStoreState) => {
				const contentIds = newGroupContent.map(({ id }) => id);
				const oldGroupContent = state.content.filter(({ id }) => !contentIds.includes(id));
				state.content = oldGroupContent.concat(newGroupContent);
			});
		},
		selectContent(contentIdToSelect: string) {
			this.$patch((state: GroupContentStoreState) => {
				state.selectedContentId = contentIdToSelect;
			});
		},
		async react(groupId: string, contentType: ContentType, contentId: string, reactionType: ReactionType) {
			const result = await reactToContent(groupId, contentType, contentId, reactionType);
			// Update separate discussion store if the content is a discussion message
			if (contentType === ContentType.DISCUSSION && result.type === ContentType.DISCUSSION) {
				useDiscussionStore().setWithMessages([result]);
				this.update([result]);
			// Find the updated file or link in the attachments to discussion messages and update in the store
			} else if (contentType !== ContentType.DISCUSSION && result.type === ContentType.DISCUSSION) {
				result.metadata.discussion.messages.forEach((message) => {
					message.attachments.contents.forEach((attachment) => {
						if (attachment.id === contentId) {
							this.update([attachment]);
							useDiscussionMessageStore().set([message]);
						}
					})
				})
			} else {
				this.update([result]);
			}
		},
	},
});
